import { all, put, takeEvery } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import {
  FETCH_ALL_PRODUCTS_REQUEST,
  FETCH_ALL_PRODUCTS_SUCCESS,
  FETCH_ALL_PRODUCTS_FAILURE,
  SET_LOADING_STATE,
  RESET_LOADING_STATE,
  CREATE_CATEGORY_REQUEST,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_FAILURE,
  CREATE_PRODUCT_REQUEST,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAILURE,
  EDIT_PRODUCT_REQUEST,
  EDIT_PRODUCT_SUCCESS,
  EDIT_PRODUCT_FAILURE,
  REMOVE_PRODUCT_REQUEST,
  REMOVE_PRODUCT_SUCCESS,
  REMOVE_PRODUCT_FAILURE,
  FETCH_ALL_CATEGORY_SUCCESS,
  FETCH_ALL_CATEGORY_FAILURE,
  FETCH_ALL_CATEGORY_REQUEST,
  EDIT_CATEGORY_REQUEST,
  EDIT_CATEGORY_SUCCESS,
  EDIT_CATEGORY_FAILURE,
  REMOVE_CATEGORY_REQUEST,
  REMOVE_CATEGORY_SUCCESS,
  REMOVE_CATEGORY_FAILURE,
  BUY_PRODUCT_REQUEST,
  BUY_PRODUCT_SUCCESS,
  BUY_PRODUCT_FAILURE,
  GET_ORDER_REQUEST,
  GET_ORDER_SUCCESS,
  GET_ORDER_FAILURE
} 
from "../constants";

import {
  firebaseCreateProduct,
  firebaseCreateCategory,
  firebaseFetchAllProducts,
  firebaseFetchAllCategories,
  firebaseEditCategory,
  firebaseRemoveProduct,
  firebaseEditProduct,
  firebaseRemoveCategory,
  firebaseBuyProductRequest,
  firebaseGetOrderRequestFn
} from "../api/api";

function* createCategoryFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseCreateCategory(payload);
    if (response) {
      yield put({ type: CREATE_CATEGORY_SUCCESS, payload: { category: response } });
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: CREATE_CATEGORY_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: CREATE_CATEGORY_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

function* createProductFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseCreateProduct(payload);
    if (response) {
      yield put({ type: CREATE_PRODUCT_SUCCESS, payload: { products: response } });
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: CREATE_PRODUCT_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: CREATE_PRODUCT_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

function* fetchAllProductsFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseFetchAllProducts(payload);
    if (response) {
      yield put({ type: FETCH_ALL_PRODUCTS_REQUEST, payload: { allProducts: response } });
      // yield put({ type: FETCH_ALL_PRODUCTS_REQUEST })
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: FETCH_ALL_PRODUCTS_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: FETCH_ALL_PRODUCTS_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

function* fetchAllCategoriesFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseFetchAllCategories(payload);
    if (response) {
      yield put({ type: FETCH_ALL_CATEGORY_SUCCESS, payload: { allCategories: response } });
      yield put({ type: FETCH_ALL_CATEGORY_REQUEST })
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: FETCH_ALL_CATEGORY_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: FETCH_ALL_PRODUCTS_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

function* editCategoryFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseEditCategory(payload);
    if (response) {
      console.log(response);
      yield put({ type: EDIT_CATEGORY_SUCCESS, payload: { category: response } });
      yield put({ type: FETCH_ALL_CATEGORY_REQUEST });
      yield put({ type: FETCH_ALL_PRODUCTS_REQUEST });
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: EDIT_CATEGORY_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: EDIT_CATEGORY_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

function* editProductFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseEditProduct(payload);
    if (response) {
      console.log(response);
      yield put({ type: EDIT_PRODUCT_SUCCESS, payload: { product: response } });
      yield put({ type: FETCH_ALL_PRODUCTS_REQUEST });
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: CREATE_CATEGORY_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: CREATE_CATEGORY_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}


function* removeProductFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseRemoveProduct(payload);
    if (response) {
      yield put({ type: REMOVE_PRODUCT_SUCCESS, payload: { product: response } });
      yield put({ type: FETCH_ALL_PRODUCTS_REQUEST });
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: CREATE_CATEGORY_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: CREATE_CATEGORY_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

function* removeCategoryFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseRemoveCategory(payload);
    if (response) {
      yield put({ type: REMOVE_CATEGORY_SUCCESS, payload: { product: response } });
      yield put({ type: FETCH_ALL_CATEGORY_REQUEST });
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: REMOVE_CATEGORY_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: REMOVE_CATEGORY_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

function* buyProductRequestFn({ payload }: any): any {
  try {
    const response = yield firebaseBuyProductRequest(payload);
    if (response) {
      yield put({ type: BUY_PRODUCT_SUCCESS});
    } else {
      yield put({ type: BUY_PRODUCT_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: BUY_PRODUCT_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

function* getOrderRequestFn({ payload }: any): any {
  try {
    const response = yield firebaseGetOrderRequestFn(payload);
    if (response) {
      yield put({ type: GET_ORDER_SUCCESS, payload: {allOrders: response}});
    } else {
      yield put({ type: GET_ORDER_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: GET_ORDER_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

export default function* marketSaga(): SagaIterator {
  yield all([
    takeEvery(CREATE_CATEGORY_REQUEST, createCategoryFn),
    takeEvery(CREATE_PRODUCT_REQUEST, createProductFn),
    takeEvery(EDIT_PRODUCT_REQUEST, editProductFn),
    takeEvery(REMOVE_PRODUCT_REQUEST, removeProductFn),
    takeEvery(REMOVE_CATEGORY_REQUEST, removeCategoryFn),
    takeEvery(FETCH_ALL_PRODUCTS_REQUEST, fetchAllProductsFn),
    takeEvery(FETCH_ALL_CATEGORY_REQUEST, fetchAllCategoriesFn),
    takeEvery(EDIT_CATEGORY_REQUEST, editCategoryFn),
    takeEvery(BUY_PRODUCT_REQUEST, buyProductRequestFn),
    takeEvery(GET_ORDER_REQUEST, getOrderRequestFn),
  ]);
}
